import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-24739f9c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "conten"
};
var _hoisted_2 = {
  class: "hear"
};
var _hoisted_3 = {
  class: "detail"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hearText"
  }, [/*#__PURE__*/_createElementVNode("p", null, "组织详情")], -1);
});

var _hoisted_5 = {
  class: "con"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "detail-title padding6"
  }, " 组织简介 ", -1);
});

var _hoisted_7 = {
  class: "detail-content"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" 支部成员");

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "detail-title padding6"
  }, " 组织地址 ", -1);
});

var _hoisted_10 = {
  class: "detail-content"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "detail-title padding6"
  }, " 组织电话 ", -1);
});

var _hoisted_12 = {
  class: "detail-content"
};
import Breads from "@/components/Breads/index.vue";
import { useRoute } from "vue-router";
import { onMounted, reactive, ref } from "vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import PublicUserDetail from "./components/PublicUserDetail.vue";
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var detail = reactive({
      allPath: [{
        path: "/organization",
        name: "组织架构",
        query: {}
      }]
    });
    onMounted(function () {
      getOrganizeDetail(route.query.orgId);
    });
    var orgDetail = ref({});

    var getOrganizeDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(orgId) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof orgId === 'string')) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getOrganizeDetail"]({
                  organizeId: orgId
                });

              case 3:
                res = _context.sent;
                orgDetail.value = res.data;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getOrganizeDetail(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var PublicUserDetailRef = ref();

    var handleUserDetail = function handleUserDetail() {
      var _PublicUserDetailRef$;

      if (orgDetail.value.users.length == 0) return;
      (_PublicUserDetailRef$ = PublicUserDetailRef.value) === null || _PublicUserDetailRef$ === void 0 ? void 0 : _PublicUserDetailRef$.init(orgDetail.value);
    };

    return function (_ctx, _cache) {
      var _unref$users;

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Breads, {
        allpath: _unref(detail).allPath
      }, null, 8, ["allpath"])]), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(orgDetail).description || "无"), 1), _createElementVNode("div", {
        class: "detail-title cursor padding32",
        onClick: handleUserDetail
      }, [_hoisted_8, _createElementVNode("span", null, _toDisplayString((_unref$users = _unref(orgDetail).users) === null || _unref$users === void 0 ? void 0 : _unref$users.length) + "个", 1)]), _hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(orgDetail).address || "无"), 1), _hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(orgDetail).telephone || "无"), 1)])]), _createVNode(PublicUserDetail, {
        ref: function ref(_value, _refs) {
          _refs['PublicUserDetailRef'] = _value;
          PublicUserDetailRef.value = _value;
        }
      }, null, 512)]);
    };
  }
});